import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';

export const REMOVE_LIKE = 'REMOVE_LIKE';

export class RemoveLikeAction implements IDialogAction {
    public readonly type = REMOVE_LIKE;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(): any {
        if(this._service) {
            this._service.addLike(this.payload.ids, false);
        }
        return;
    }
    public reducer(state: any): any {
        return state;
    }
}